import { render, staticRenderFns } from "./dice-choice.vue?vue&type=template&id=3550a640&scoped=true&"
import script from "./dice-choice.js?vue&type=script&lang=js&"
export * from "./dice-choice.js?vue&type=script&lang=js&"
import style0 from "./dice-choice.scss?vue&type=style&index=0&id=3550a640&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3550a640",
  null
  
)

export default component.exports